/**
 * This is a panel (wrapper). Anything comes inside lools like it's a panel :D
 *
 * TODO: in the future, we can make it stateful and then add something like collapse etc and so on
 *
 * 1. we can also add a loading screen
 *
 * @parent anybody
 * @children anybody
 * @stateless
 */
import React from 'react'
import PropTypes from 'prop-types'
import "./PanelWrapper.scss";
import classnames from 'classnames';

export class PanelCurtain extends React.Component {
  render() {
    let style = {}
    if (global['--classtop-main-section']) {
      const { height } = global['--classtop-main-section'].getBoundingClientRect();
      style = { height: height, }
    }

    return (
      <div className='panel-layer' style={style} >
        {this.props.children}
      </div>
    );
  }
}

class PanelWrapper extends React.Component {
  render() {
    let style = {}
    if (global['--classtop-main-section']) {
      const { height } = global['--classtop-main-section'].getBoundingClientRect();
      style = { minHeight: height - 170, }
    }
    
    const {
      title,
    } = this.props;

    return (
      <div className={classnames('panel-wrapper', this.props.className)} >
				<div className='panel-wrapper-content' style={style} >
          { title && <div className='panel-title'>{title}</div> }
					{this.props.children}
				</div>
			</div>
    )
  }
}

export default PanelWrapper



// WEBPACK FOOTER //
// ./src/components/UI/PanelWrapper/index.js